export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 24px',
    borderRadius: '12px',
    border: '1px solid #EDEFF7',
    background: '#fff',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flex: 1,
    minWidth: 0,
  },
  name: {
    fontFamily: 'Inter',
    lineHeight: '146%',
    color: '#23252F',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '14px',
  },
};
